import React from 'react';

import TEXT from '../../../../../../data/text.json';

import TextBox from '../../../form-components/text-box';
import TextArea from '../../../form-components/text-area';

export default ({
  itemNameValue,
  setItemNameValue,
  itemDescValue,
  setItemDescValue
}) => (
  <div>
    <TextBox
      required
      id={TEXT.FORMS.itemNameId}
      label={TEXT.FORMS.itemNameLabel}
      placeholder={TEXT.FORMS.itemNamePlaceholder}
      value={itemNameValue}
      onChange={setItemNameValue}
    />

    <TextArea
      id={TEXT.FORMS.itemDescId}
      label={TEXT.FORMS.itemDescLabel}
      placeholder={TEXT.FORMS.itemDescPlaceholder}
      value={itemDescValue}
      onChange={setItemDescValue}
    />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/contribution-form/forms/edit-item-form/stage-1/index.js